var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCurve({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 70,
    viewBox: "0 0 1439 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1439V35.8142C1439 35.8142 1018.07 69.5 734 69.5C449.928 69.5 0 35.8142 0 35.8142V0Z",
    fill: "#00EFC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCurve);
export default __webpack_public_path__ + "static/media/green-curve.be7e8a5328d1c29463c698abcc136b4e.svg";
export { ForwardRef as ReactComponent };